import { useMemo } from "react";
import { useOrganization } from "./useAPI";
import { planMeets, type RequiredPlan, PLAN_ORDER } from "../app/components/PlanGate";

type PlanTier = (typeof PLAN_ORDER)[number];

interface UsePlanFeaturesResult {
  currentPlan: PlanTier;
  isLoading: boolean;
  meets: (required: RequiredPlan) => boolean;
  isAtLeast: (required: RequiredPlan) => boolean;
  isSandbox: boolean;
  isScalePlus: boolean;
  isGovernancePlus: boolean;
  isEnterprisePlus: boolean;
}

export function usePlanFeatures(): UsePlanFeaturesResult {
  const orgQuery = useOrganization();

  return useMemo(() => {
    const planRaw = (orgQuery.data as any)?.organization?.plan ?? (orgQuery.data as any)?.plan;
    const currentPlan: PlanTier =
      typeof planRaw === "string" && (PLAN_ORDER as readonly string[]).includes(planRaw)
        ? (planRaw as PlanTier)
        : "sandbox";

    const meets = (required: RequiredPlan): boolean => planMeets(currentPlan, required);

    return {
      currentPlan,
      isLoading: orgQuery.isLoading,
      meets,
      isAtLeast: meets,
      isSandbox: currentPlan === "sandbox",
      isScalePlus: meets("scale"),
      isGovernancePlus: meets("governance"),
      isEnterprisePlus: meets("enterprise"),
    };
  }, [orgQuery.data, orgQuery.isLoading]);
}
